import React from 'react'
import { motion } from 'framer-motion'

const CustomTabs = ({ children, value, onChange }) => {
	return (
		<div style={{ width: '100%' }}>
			<div
				style={{
					width: '100%',
					borderRadius: '6px',
					backgroundColor: 'white',
					display: 'flex',
					padding:'0 32px',
					gap: 0,
					justifyContent: 'space-between',
					boxShadow: ' 0px 4px 16px 0px rgba(17, 34, 17, 0.05)',
				}}
			>
				<div
					style={{
						display: 'flex',
						gap: '0',
						justifyContent: 'space-between',
						width: '100%',
						height: '80px',
					}}
				>
					{children}
				</div>
			</div>
		</div>
	)
}

const Tab = ({ value, header, caption, onChange, selectedValue }) => {
	const isSelected = selectedValue === value

	return (
		<motion.button
			whileHover={{ scale: 1.02 }}
			whileTap={{ scale: 0.98 }}
			onClick={() => onChange(value)}
			style={{
				padding: '0.5rem 1rem',
				cursor: 'pointer',
				border: 'none',
				background: 'transparent',
				minWidth: '120px',
				transition: 'all 200ms',
				color: isSelected ? '#2563eb' : '#4b5563',
				position: 'relative',
				height: '100%',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent:'center',
					gap: '8px',
					height: '100%',
					position: 'relative',
					// border:'2px solid red'
					// borderBottom: isSelected ? '2px solid #2563eb' : 'none',
				}}
			>
				<span
					style={{
						fontWeight: 400,
						fontSize: '14px',
						color: '#000',
					}}
				>
					{header}
				</span>
				<span
					style={{
						fontSize: '14px',
						marginTop: '0.125rem',
						opacity: 0.7,
						color: 'rgba(17, 34, 17, 1)',
					}}
				>
					{caption}
				</span>
			</div>

			{isSelected && (
				<motion.div
					layoutId="activeTab"
					style={{
						position: 'absolute',
						bottom: 0,
						left: 0,
						right: 0,
						height: '2px',
						backgroundColor: 'rgba(141, 211, 187, 1)',
					}}
					initial={false}
					transition={{
						type: 'spring',
						stiffness: 500,
						damping: 30,
					}}
				/>
			)}
		</motion.button>
	)
}

const TabPanel = ({ children, value, selectedValue }) => {
	if (value !== selectedValue) return null

	return (
		<motion.div
			initial={{ opacity: 0, y: 10 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.2 }}
			style={{ padding: '16px' }}
		>
			{children}
		</motion.div>
	)
}

export { CustomTabs, Tab, TabPanel }
